/**
 * @desc 待录入计费重信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDjfRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/djfTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
